import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useRef, useMemo, useState } from 'react';
import ReactResizeDetector from 'react-resize-detector/build/withPolyfill';
import { propArrayShape } from '../../../../helpers/custom-prop-types';
import { useBoolState } from '../../../../helpers/use/useHook';
import ProfessionalUnitProjectCareerMiddleTask from './ProfessionalUnitProjectCareerMiddleTask';
const ProfessionalUnitProjectCareerMiddleTasks = (props) => {
    const { middleTasks } = props;
    const { boolState: isShowMore, changeFalse: hideMore, changeTrue: showMore, } = useBoolState(false);
    const { boolState: isOpen, changeTrue: open } = useBoolState(false);
    const ref = useRef();
    const [lastVisiblePosition, changeLastVisiblePosition] = useState(0);
    const moreStyle = useMemo(() => ({ left: lastVisiblePosition }), [lastVisiblePosition]);
    const onResize = useCallback(() => {
        if (!ref.current || isOpen) {
            return;
        }
        const { clientHeight, scrollHeight } = ref.current;
        if (!(scrollHeight > clientHeight)) {
            hideMore();
            return;
        }
        const elements = ref.current.querySelectorAll('.project_career_middle_task');
        let visibleWidth = 0;
        let isLineBreak = false;
        let margin = 0;
        for (let i = 0; i < elements.length; i += 1) {
            const element = elements.item(i);
            const prevElement = elements.item(i - 1);
            if (!isLineBreak &&
                prevElement &&
                prevElement.offsetTop !== element.offsetTop) {
                isLineBreak = true;
            }
            if (!isLineBreak) {
                const { marginRight } = window.getComputedStyle(element);
                margin = marginRight ? marginRight.replace(/[^0-9]/g, '') : 0;
                visibleWidth += element.clientWidth + parseInt(margin, 10);
            }
        }
        showMore();
        changeLastVisiblePosition(visibleWidth);
    }, [ref, isOpen, showMore, hideMore, changeLastVisiblePosition]);
    const onClickMore = useCallback(() => {
        open();
        hideMore();
    }, [open, hideMore]);
    if (!middleTasks.length) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'project_career_middle_tasks_box' }, { children: [isShowMore && !isOpen && (_jsx("button", Object.assign({ className: 'project_career_middle_tasks_more', onClick: onClickMore, style: moreStyle, type: 'button' }, { children: "[...]" }))), _jsx(ReactResizeDetector, Object.assign({ onResize: onResize, targetRef: ref }, { children: _jsx("ul", Object.assign({ className: clsx('project_career_middle_tasks', isOpen && 'is-open'), ref: ref }, { children: middleTasks.map((v) => (_jsx(ProfessionalUnitProjectCareerMiddleTask, { name: v.name }, v.id))) })) }))] })));
};
ProfessionalUnitProjectCareerMiddleTasks.propTypes = {
    middleTasks: propArrayShape().isRequired,
};
export default ProfessionalUnitProjectCareerMiddleTasks;
